<template>
  <div class="left-nav">
    <slot></slot>
  </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped lang="scss">
  .left-nav{
    width: 210px;
    overflow-y: auto;
    overflow-x:hidden;
    /*display: inline-block;*/
    vertical-align: top;
    position: relative;
    z-index: 2;
    flex-shrink: 0;
  }
  /*.left-nav::-webkit-scrollbar {*/
  /*  width: 6px;*/
  /*  height: 2px;*/
  /*}*/
  /*.left-nav::-webkit-scrollbar-thumb {*/
  /*  border-radius: 10px;*/
  /*  background-color:rgba(144,147,153,0);*/
  /*  transition: background-color .3s;*/
  /*  border: none;*/
  /*}*/
  /*.left-nav:hover::-webkit-scrollbar-thumb{*/
  /*  background-color:rgba(144,147,153,.3);*/
  /*}*/
</style>



// WEBPACK FOOTER //
// UI/Aside/index.vue